import { EXT_TO_WEB_TYPE } from 'common/messaging'

export const listenToExtension = (expectedAction, callback) => {
  const extensionListener = async (msg) => {
    if (!msg.origin || msg.origin !== window.location.origin) return

    const { type, payload } = msg.data

    if (type === EXT_TO_WEB_TYPE) {
      const { actionName, args } = payload
      if (expectedAction === actionName) return await callback(...args)
    } else if (type) {
      if (type === 'HEY_EXTENSION_PLS_FORWARD_TO_BG_KTHNX') return // other known traffic
      console.log(
        `[extensionListener]: received unexpected type while listening for ${expectedAction}`,
        msg.data,
      )
    } else {
      if (msg.data.__msgId) return // probably other known traffic
      if (msg.data.source === 'react-devtools-bridge') return

      console.log(
        `[extensionListener]: unknown message format while listening for ${expectedAction}`,
        msg.data,
      )
    }
  }

  window.addEventListener('message', extensionListener)
  return () => window.removeEventListener('message', extensionListener)
}
